import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className }) {
  const { t } = useTranslation();
  const styles = {
    pending: "bg-[var(--status-pending-bg)] text-[color:var(--status-pending-fg)] border-[color:var(--status-pending-fg)]/30",
    confirmed: "bg-[var(--status-confirmed-bg)] text-[color:var(--status-confirmed-fg)] border-[color:var(--status-confirmed-fg)]/30",
    cancelled: "bg-[var(--status-cancelled-bg)] text-[color:var(--status-cancelled-fg)] border-[color:var(--status-cancelled-fg)]/30",
  };
  const labels = {
    pending: t("booking.statusPending"),
    confirmed: t("booking.statusConfirmed"),
    cancelled: t("booking.statusCancelled"),
  };
  return (
    <Badge
      variant="outline"
      className={cn("rounded-full border font-medium", styles[status], className)}
      data-testid="booking-status-badge"
    >
      {labels[status] || status}
    </Badge>
  );
}
